import Navbar from "./Navbar";
import Footer from "./Footer";
import Chatbot from "@/components/Chatbot";
import { Toaster } from "@/components/ui/sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <Chatbot />
      <Toaster position="top-right" richColors />
    </div>
  );
}
